import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import {
  Radio,
  Grid,
  Box,
  useTheme,
  useMediaQuery,
  makeStyles
} from '@material-ui/core';
import { Lock, InfoOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginBottom: 84,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 100
      }
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 40,
      '& .MuiSvgIcon-root': {
        marginLeft: 18,
        color: colorSet.gray600
      }
    },
    gridItemBox: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderRadius: 4,
      border: `1px solid ${colorSet.gray400}`,
      padding: 16,
      '& .box-title': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 8,
        '& .MuiSvgIcon-root': {
          marginRight: 8
        }
      }
    }
  };
});

interface Props {
  onClick: () => void;
}

const DrawingFilesPermissionPresenter: React.FC<Props> = ({ onClick }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <CustomizedTypography
          variant={matches ? 'h3' : 'h2'}
          fontWeight="bold"
          color="textPrimary"
          align="center"
        >
          도면 보안 설정을 해주세요
        </CustomizedTypography>
        <InfoOutlined fontSize="small" />
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box className={classes.gridItemBox} onClick={onClick}>
            <Radio color="primary" />
            <div className="box-title">
              <Lock />
              <CustomizedTypography
                variant={matches ? 'body1' : 'h4'}
                fontWeight="bold"
                color="textPrimary"
              >
                모든 파트너 도면 다운로드 가능
              </CustomizedTypography>
            </div>
            <CustomizedTypography
              variant="body2"
              color="textSecondary"
              align="left"
            >
              &bull; 모든 파트너가 도면을 다운로드할 수 있습니다.
              <br />
              &bull; 가장 정확한 견적을 받을 수 있습니다.
              <br />
              &bull; 다운로드 권한은 보안 설정에서 수정할 수 있습니다.
            </CustomizedTypography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box className={classes.gridItemBox} onClick={onClick}>
            <Radio color="primary" />
            <div className="box-title">
              <Lock />
              <CustomizedTypography
                variant={matches ? 'body1' : 'h4'}
                fontWeight="bold"
                color="textPrimary"
              >
                허용된 파트너만 도면 다운로드 가능
              </CustomizedTypography>
            </div>
            <CustomizedTypography variant="body2" color="textSecondary">
              &bull; 신뢰하는 파트너에게만 다운로드 권한을 부여합니다.
              <br />
              &bull; 모든 파트너는 도면뷰어에서 도면형상을 볼 수 있습니다.
              <br />
              &bull; 다운로드 권한은 보안 설정에서 수정할 수 있습니다.
            </CustomizedTypography>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default DrawingFilesPermissionPresenter;
